module.exports = __webpack_public_path__ + "fonts/0342291.ttf";